export default (store, childRoutes) => ({
  path:'*',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const NotFoundPage = require('./components').default
      cb(null, NotFoundPage)
    }, 'not_found_page')
  }
})



// WEBPACK FOOTER //
// ./src/routes/NotFoundPage/index.js